// project imports
import config from '../config';

// action - state management
import * as actionTypes from './actions';

export const SET_MODE = 'SET_MODE';

const savedMode = localStorage.getItem('themeMode');

export const initialState = {
    isOpen: [], //for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    opened: true,
    // Azul e índigo "estilo Apple" (as mesmas cores de sistema usadas em
    // macOS/iOS) no lugar do azul/roxo padrão do Material UI - troca a
    // paleta do app inteiro, já que MuiButton/etc herdam de
    // palette.primary/secondary (ver themes/palette.js).
    primaryColor: '#0071e3',
    secondaryColor: '#5e5ce6',
    bgColor: '#ffffff',
    textColor: '#1a1a1a',
    fontSize: 14,
    mode: savedMode || 'light' // light / dark
};

//-----------------------|| CUSTOMIZATION REDUCER ||-----------------------//

const customizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            const id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.SET_SECONDARY_COLOR:
            return {
                ...state,
                secondaryColor: action.secondaryColor
            };
        case SET_MODE:
            return {
                ...state,
                mode: action.payload
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };

        case actionTypes.SET_PRIMARY_COLOR:
            return {
                ...state,
                primaryColor: action.primaryColor
            };
        case actionTypes.SET_BG_COLOR:
            return {
                ...state,
                bgColor: action.bgColor
            };
        case actionTypes.SET_TEXT_COLOR:
            return {
                ...state,
                textColor: action.textColor
            };
        case actionTypes.SET_FONT_SIZE:
            return {
                ...state,
                fontSize: action.fontSize
            };
        default:
            return state;
    }
};

export default customizationReducer;
